import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonos = [{
    title: 'Bono 1',
    desc: '17 plantillas de WhatsApp con atajos para WhatsApp Business.'
  }, {
    title: 'Bono 2',
    desc: 'Guía completa para situaciones difíciles: diagnósticos graves, eutanasia y dueños conflictivos.'
  }, {
    title: 'Bono 3',
    desc: '12 infografías para sala de espera listas para imprimir o subir a Instagram.'
  }, {
    title: 'Bono 4',
    desc: 'Receta veterinaria profesional editable + tablas de posología de referencia.'
  }, {
    title: 'Bono 5',
    desc: 'Checklist completo de apertura de clínica: legal, equipamiento y primeros clientes.'
  }, {
    title: 'Bono 6',
    desc: 'Protocolo de derivación a especialista con 3 modelos de carta listos para usar.'
  }];
  return <section className="px-4 max-w-6xl mx-auto" data-id="element-27">
      <FadeIn data-id="element-28">
        <h3 className="text-2xl md:text-4xl font-black text-brand-white text-center mb-8 md:mb-12 flex items-center justify-center gap-3" data-id="element-29">
          <Gift className="text-brand-gold w-8 h-8 md:w-10 md:h-10" data-id="element-30" /> LOS 6
          BONOS INCLUIDOS
        </h3>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-31">
        {bonos.map((bono, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-32">
            <div className="bg-brand-green border border-brand-green-hover rounded-xl p-5 md:p-6 flex gap-4 items-start h-full" data-id="element-33">
              <div className="bg-brand-gold text-brand-dark font-black text-sm md:text-base px-2.5 py-1 rounded shrink-0 mt-0.5" data-id="element-34">
                {bono.title}
              </div>
              <p className="text-brand-cream font-medium text-sm md:text-base leading-relaxed" data-id="element-35">
                {bono.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}